<template>
  <div>
    <div id="control-container">
      <div class="play">
        <img
          class="play-image"
          v-if="isActive == true"
          @click="isActive = !isActive"
          src="../assets/pause.png"
          alt="pause button"
        />
        <img
          class="play-image"
          v-if="isActive == false"
          @click="isActive = !isActive"
          src="../assets/play.png"
          alt="play button"
        />
      </div>
      <div class="status">
        <div
          class="progress"
          :style="{ backgroundColor: episode_cards[episode_index]['color'] }"
        />
      </div>

      <div class="skip-left" @click="$store.commit('prevPart')">
        <img class="skip-image" src="../assets/skip-left.png" alt="" />
      </div>

      <div class="part-stream">
        <div class="part-progress" />
      </div>
      <div class="skip-right" @click="$store.commit('nextPart')">
        <img class="skip-image" src="../assets/skip-right.png" alt="" />
      </div>
      <div class="playlist" @click="changePartsEpisodeState()">
        <img class="playlist-image" src="../assets/playlist.png" alt="" />
      </div>

      <audio
        id="audioPlayer"
        ref="audioPlayer"
        @playing="playing"
        @pause="paused"
        @ended="nextChunk"
        src=""
      ></audio>
    </div>
  </div>
</template>

<script>
import eyal from "../data/episode_transcripts/eyal.json";
import benedicte from "../data/episode_transcripts/benedicte.json";
import priya from "../data/episode_transcripts/priya.json";
import mark from "../data/episode_transcripts/mark.json";
import fred from "../data/episode_transcripts/fred.json";
import rabih from "../data/episode_transcripts/rabih.json";
import christina from "../data/episode_transcripts/christina.json";
import ixmucane from "../data/episode_transcripts/ixmucane.json";
import claudia from "../data/episode_transcripts/claudia.json";
import { mapState } from "vuex";
import parts_episode from "../data/parts_episode.json";
import config from "../data/ecchr_config.json";

export default {
  name: "Player",
  data() {
    return {
      isActive: false,
      observer: null,
      chunks: [
        eyal["chunk_sequence"],
        benedicte["chunk_sequence"],
        priya["chunk_sequence"],
        fred["chunk_sequence"],
        rabih["chunk_sequence"],
        christina["chunk_sequence"],
        claudia["chunk_sequence"],
        mark["chunk_sequence"],
        ixmucane["chunk_sequence"],
      ],
      chunk_index: 1,
      episode_http: "https://ecchr.metasphere.xyz/episodes/",
      episode_format: "/mp3/Chunks/",
      part_start: 0,
      part_end: 0,
      part_range: 0,
      exploreRelatedContent: false,
      episode_cards: config["episode_cards"],
    };
  },
  computed: {
    ...mapState([
      "episode_id",
      "episode_index",
      "episode_length",
      "chunkPlayback",
      "currentPart",
      "currentPartIndex",
      "episode_intro_length",
      "episode_last_chunk",
      "device_mode",
      "entityObject",
    ]),
  },
  mounted() {
    const playerContainer = document.getElementById("control-container");
    if (this.device_mode == "mobile") {
      playerContainer.style.width = "100%";
      playerContainer.style.height = "10vh";
    } else {
      playerContainer.style.width = "375px";
      playerContainer.style.height = "74px";
    }

    let progress = document.querySelector(".progress");
    progress.style.setProperty("--width-max", this.episode_length);

    // const chunks_viewport = document.querySelectorAll(".chunk");
    // const options = this.setChunkSelectArea();

    // this.observer = new IntersectionObserver(([entry]) => {
    //   if (entry && entry.isIntersecting) {
    //     this.chunkPlayback = entry.target["id"];
    //     console.log("intersection: " + this.chunkPlayback);
    //     this.selectChunk(entry.target);
    //     setTimeout(function () {
    //       this.loadPlayAudio();
    //     }, 100);
    //   } else {
    //     this.deselectChunk(entry.target);
    //   }
    // }, options);

    // chunks_viewport.forEach((chunk_viewport) => {
    //   this.observer.observe(chunk_viewport);
    // });
  },
  // destroyed() {
  //   this.observer.disconnect();
  // },
  watch: {
    device_mode: function (device_mode) {
      const playerContainer = document.getElementById("control-container");
      if (device_mode == "mobile") {
        playerContainer.style.width = "100%";
        playerContainer.style.height = "10vh";
        playerContainer.classList.remove("player-desktop");
        playerContainer.classList.add("player-mobile");
      } else {
        playerContainer.style.width = "375px";
        playerContainer.style.height = "74px";
        playerContainer.classList.remove("player-mobile");
        playerContainer.classList.add("player-desktop");
      }
    },
    isActive: function (val) {
      if (val == true) {
        if (this.chunkPlayback == "") {
          const introChunk = "01-Intro.mp3";
          this.$store.commit("updateChunkPlayback", introChunk);
          this.loadPlayAudio();
        }
        document.getElementById("audioPlayer").play();
      } else {
        document.getElementById("audioPlayer").pause();
      }
    },
    chunkPlayback: function (val) {
      var chunk_scroll = document.getElementById(val);
      let chunks_viewport = document.querySelectorAll(".chunk");
      chunks_viewport.forEach((chunk_viewport) => {
        this.deselectChunk(chunk_viewport);
      });

      this.removeEntityMarks();

      // if (chunk_scroll != null) {
      this.selectChunk(chunk_scroll);
      // }

      const episodeChunks = this.chunks[this.episode_index];
      var playbackIndex = episodeChunks
        .map((chunk) => chunk.source_file)
        .indexOf(val);

      this.$store.commit("updatePlaybackIndex", playbackIndex);

      if (
        playbackIndex != -1 &&
        this.entityObject[playbackIndex] != undefined
      ) {
        const chunk_div = document.getElementById(this.chunkPlayback + "_text");
        const text = chunk_div.innerHTML;
        this.entityMarker(chunk_div, text, this.entityObject[playbackIndex]);
      }

      var r = /\d+/;
      let index = this.chunkPlayback.match(r);
      this.chunk_index = index;
      this.loadPlayAudio();
    },
    chunk_index: function (index) {
      let progress = document.querySelector(".progress");
      progress.style.setProperty("--width", index);
      let part_stream = ((index - this.part_start) / this.part_range) * 100;
      let part_progress = document.querySelector(".part-progress");
      part_progress.style.setProperty("--part-progress-width", part_stream);
    },
    episode_length: function (episode_length) {
      let progress = document.querySelector(".progress");
      progress.style.setProperty("--width-max", episode_length);
    },
    currentPartIndex: function (currentPartIndex) {
      this.part_start = parts_episode[this.episode_id][currentPartIndex].start;
      this.part_end = parts_episode[this.episode_id][currentPartIndex].end;
      this.part_range = this.part_end - this.part_start;
    },
  },
  methods: {
    changeEploreRelatedContent() {
      this.$store.commit("toggleExploreRelatedContent");
    },
    changePartsEpisodeState() {
      this.$store.commit("togglePartsEpisode");
    },
    playing() {
      this.isActive = true;
    },
    paused() {
      this.isActive = false;
    },
    nextChunk() {
      let audio = document.getElementById("audioPlayer");
      var r = /\d+/;
      let next_source = "";
      let intro_chunk_index = this.chunkPlayback.match(r);
      let chunk_index = this.chunkPlayback.match(r);

      const intro = this.chunkPlayback.split("-")[1];
      if (
        intro == "Intro.mp3" &&
        this.chunkPlayback !== "06-Intro.mp3" &&
        this.episode_intro_length != this.chunkPlayback
      ) {
        let current_index = parseInt(intro_chunk_index);
        current_index = current_index + 1;
        next_source = "0" + current_index + "-Intro.mp3";
      } else if (this.episode_intro_length == this.chunkPlayback) {
        next_source = this.chunks[this.episode_index][0]["source_file"];
      } else if (this.episode_last_chunk == this.chunkPlayback) {
        next_source = "9999-Outro.mp3";
      } else {
        let current_chunk = this.chunks[this.episode_index][chunk_index];
        next_source = current_chunk["source_file"];
      }
      audio.src =
        this.episode_http + this.episode_id + this.episode_format + next_source;
      audio.load();

      this.$store.commit("updateChunkPlayback", next_source);

      setTimeout(function () {
        audio.play();
      }, 100);
    },
    entityMarker(chunk_div, text, entities) {
      if (entities.length > 0) {
        let entityColor = chunk_div.id.split("-")[1];
        entityColor = entityColor.split(".")[0].toLowerCase();
        let entityEntries = chunk_div.querySelectorAll(".inactive");

        entityEntries.forEach((entry) => {
          entry.classList.add(entityColor + "-entity");
        });
      }
    },
    removeEntityMarks() {
      const spanText = document.querySelectorAll(".inactive");
      spanText.class;
      spanText.forEach((span) => {
        span.removeAttribute("class");
        span.classList.add("inactive");
      });
    },
    selectChunk(element) {
      let childs = element.childNodes;
      if (
        element.parentNode.id != "trigger-warning" &&
        element.childNodes.length > 1
      ) {
        element.style.backgroundColor = "rgba(44, 44, 44, 1)";
        element.firstChild.style.opacity = "1.0";
        childs[1].style.color = "rgb(240, 240, 240)";
      } else if (
        element.parentNode.id != "trigger-warning" &&
        element.childNodes.length == 1
      ) {
        element.firstChild.style.opacity = "1.0";
        element.firstChild.style.color = "rgb(240, 240, 240)";
        element.style.backgroundColor = "rgba(44, 44, 44, 1)";
      } else if (element.parentNode.id == "trigger-warning") {
        element.firstChild.style.opacity = "1.0";
        element.style.backgroundColor = "rgba(150, 0, 0, 0.7)";
      }

      var topPos = element.offsetTop - 90;
      const episodeContainer = document.getElementById("app");
      episodeContainer.scrollTo({
        top: topPos,
        behavior: "smooth",
      });

      this.changeEploreRelatedContent();
    },
    deselectChunk(element) {
      element.style.backgroundColor = "rgba(30, 30, 30, 1)";
      element.firstChild.style.opacity = "0.3";
      if (element.childNodes.length > 1) {
        let childs = element.childNodes;
        childs[1].style.color = "rgba(100, 100, 100, 1)";
      }
    },
    loadPlayAudio() {
      let audio = document.getElementById("audioPlayer");
      audio.src =
        this.episode_http +
        this.episode_id +
        this.episode_format +
        this.chunkPlayback;
      audio.load();
      if (this.isActive == true) {
        audio.play();
      }
    },
    // setChunkSelectArea() {
    //   let intViewportHeight = window.innerHeight;
    //   let topThirdViewportHeight = Math.round((1 / 3) * intViewportHeight);

    //   const options = {
    //     root: null,
    //     rootMargin: `0px -30px ${-1.9 * topThirdViewportHeight}px -50px`,
    //     threshold: 0.5,
    //   };
    //   return options;
    // },
  },
};
</script>

<style scoped>
#control-container {
  z-index: 3;
  background-color: rgba(28, 28, 30, 1);
  display: grid;
  grid-template-columns: 0.4fr 0.3fr 1fr 0.3fr 0.3fr;
  grid-template-rows: 0.1fr 1fr;
  gap: 0px 0px;
  grid-template-areas:
    "status status status status status"
    "play skip-left part-stream skip-right playlist";
}

.player-desktop {
  position: sticky;
  bottom: 0;
  z-index: 2;
}

.player-mobile {
  position: fixed;
  bottom: 0px;
  z-index: 100;
}

/* .control-fixed {
  position: fixed;
  bottom: 0;
} */

.play {
  grid-area: play;
  place-self: center;
}

.play-image {
  width: 43px;
}

.play-image:hover {
  cursor: pointer;
}

.skip-left {
  grid-area: skip-left;
  place-self: center;
}

.skip-image {
  width: 12px;
}

.skip-image {
  cursor: pointer;
}

.stream {
  width: 100%;
  grid-area: stream;
  place-self: center;
}

.skip-right {
  grid-area: skip-right;
  place-self: center;
}

.playlist {
  grid-area: playlist;
  place-self: center;
}

.playlist:hover {
  cursor: pointer;
}

.playlist-image {
  width: 12px;
}

.status {
  grid-area: status;
  place-self: center;
  background: rgba(66, 66, 66, 0.7);
  height: 4px;
  width: 100%;
  filter: drop-shadow(0px 2px 3px rgba(44, 44, 44, 0.7));
}

.progress {
  height: 4px;
  background: rgb(255, 235, 204, 0.7);
  /* background-color: rgba(148, 181, 192, 0.7); */
  --width: 1;
  width: calc((var(--width) / var(--width-max)) * 100%);
  transition: 0.2s ease-in-out;
}

.part-stream {
  grid-area: part-stream;
  place-self: center;
  background: rgba(66, 66, 66, 0.7);
  height: 4px;
  width: 100%;
  max-width: 100%;
  border-radius: 2px;
}

.part-progress {
  height: 4px;
  background: rgb(255, 235, 204, 0.7);
  background-color: rgba(255, 255, 255, 0.8);
  --part-progress-width: 1;
  --max-part-width: 100;
  width: calc((var(--part-progress-width) / var(--max-part-width)) * 100%);
  max-width: 100%;
  border-radius: 2px;
  transition: 0.2s ease-in-out;
}
</style>